import React, { useState } from 'react';
import { Select, message, AutoComplete } from 'antd';
import { DeleteOutlined, PlusOutlined, CloseOutlined, EditOutlined } from '@ant-design/icons';

const RelativesInfo = ({ relativesData, setRelativesData, selectors, setChangedData, allowedEdit }) => {
  const [showRelativesModal, setShowRelativesModal] = useState(false);
  const [editRelatives, setEditRelatives] = useState(false);
  const [editRelativesIndex, setEditRelativesIndex] = useState(0);
  const [newRelativesData, setNewRelativesData] = useState({
    RelationshipDegree: {
      Name: '',
      UID: ''
    },
    Name: '',
    BirthDate: '',
    BirthPlace_Country: {
      Name: '',
      UID: ''
    },
    Position: '',
    ResidencePlace: '',
    WorkPlace: '',
    Dependent: '',
    IsDisabled: '',
    RowKey: ''
  });
  const updateChangedData = (key, data) => {
    setChangedData(prevState => ({
        ...prevState,
        [key]: data
    }));
  };  

  const handleRelativesChange = (e, option) => {
    let { name, value, dataset } = typeof e === "string" ? option : e.target;
    const { parent } = dataset;
    if(name === 'BirthDate') value += 'T00:00:00';
    if (parent) {
      if(dataset.uid) {
        setNewRelativesData(prevState => ({
            ...prevState,
            [parent]: {
                ...prevState[parent],
                [name]: value,
                UID: dataset.uid
            }
        }));
      } else {
        setNewRelativesData(prevState => ({
            ...prevState,
            [parent]: {
                ...prevState[parent],
                [name]: value
            }
        }));
      }
    } else {
        setNewRelativesData(prevState => ({
            ...prevState,
            [name]: value
        }));
    }
  };

  const handleBirthPlaceCountryChange = (value) => {
    let parent = 'BirthPlace_Country';
    setNewRelativesData(prevState => ({
        ...prevState,
        [parent]: {
            ...prevState[parent],
            Name: value,
            UID: ''
        }
    }));
  }

  const handleAddRelativesRow = (e) => {
      e.preventDefault();
      if(Date.parse(newRelativesData.BirthDate) > Date.now()) {
        message.warning('Дата рождения не может быть больше текущей даты!')
      } else if (newRelativesData.RelationshipDegree.Name.length === 0) {
        message.warning('Выберите степень родства родственника!')
      } else if (newRelativesData.Name.length === 0) {
        message.warning('Введите имя родственника!')
      } else if (newRelativesData.BirthDate.length === 0) {
        message.warning('Введите дату рождения родственника!')
      } else if (newRelativesData.BirthPlace_Country.Name.length === 0) {
        message.warning('Введите страну рождения родственника!')
      } else {
        if (editRelatives) {
          setRelativesData(prevData => {
              const newData = [...prevData];
              newData[editRelativesIndex] = newRelativesData;
              // updateChangedData('Family', newData);  Раскомментировать и закомментировать setChangedData снизу, если надо передавать всех родственников
              return newData;
          });
          setChangedData(prevState => {
            const updatedChangedData = { ...prevState };
            if (!updatedChangedData.hasOwnProperty('Family')) {
                updatedChangedData.Family = [newRelativesData];
            } else {
                if (newRelativesData.RowKey === "") {
                    const index = updatedChangedData.Family.findIndex(rel => rel.id === newRelativesData.id);
                    if (index !== -1) {
                        updatedChangedData.Family[index] = newRelativesData;
                    } else {
                        updatedChangedData.Family.push(newRelativesData);
                    }
                } else {
                    const index = updatedChangedData.Family.findIndex(rel => rel.RowKey === newRelativesData.RowKey);
                    if (index !== -1) {
                        updatedChangedData.Family[index] = newRelativesData;
                    } else {
                        updatedChangedData.Family.push(newRelativesData);
                    }
                }
            }          
            return updatedChangedData;
          });
        } else {
          newRelativesData.Deletable = true;
          newRelativesData.id = Date.now();
          setRelativesData(prevData => {
              if (prevData.length === 0 || (prevData.length === 1 && isObjectEmpty(prevData))) {
                // updateChangedData('Family', [newRelativesData]); Раскомментировать и закомментировать setChangedData снизу, если надо передавать всех родственников
                return [newRelativesData];
              } else {
                // updateChangedData('Family', [...prevData, newRelativesData]); Раскомментировать и закомментировать setChangedData снизу, если надо передавать всех родственников
                return [...prevData, newRelativesData];
              }
          });
          setChangedData(prevState => {
            const updatedChangedData = { ...prevState };
            if (!updatedChangedData.hasOwnProperty('Family')) {
                updatedChangedData.Family = [newRelativesData];
            } else {
                updatedChangedData.Family.push(newRelativesData);
            }          
            return updatedChangedData;
          });
        }
        setShowRelativesModal(false);
        setNewRelativesData({
          RelationshipDegree: {
            Name: '',
            UID: ''
          },
          Name: '',
          BirthDate: '',
          BirthPlace_Country: {
            Name: '',
            UID: ''
          },
          Position: '',
          ResidencePlace: '',
          WorkPlace: '',
          Dependent: '',
          IsDisabled: '',
          RowKey: ''
        });
        setEditRelatives(false);
        setEditRelativesIndex(-1);
      }
  };
  
  const handleCloseRelativesModal = () => {
      setShowRelativesModal(false);
      setNewRelativesData({
        RelationshipDegree: {
          Name: '',
          UID: ''
        },
        Name: '',
        BirthDate: '',
        BirthPlace_Country: {
          Name: '',
          UID: ''
        },
        Position: '',
        ResidencePlace: '',
        WorkPlace: '',
        Dependent: '',
        IsDisabled: '',
        RowKey: ''
      });
      setEditRelatives(false);
      setEditRelativesIndex(-1);
  };

  const handleRemoveRelativesRow = (index) => {
      setRelativesData(prevData => {
          const newData = [...prevData];
          if(newData[index].RowKey.length > 0) {
            newData[index].delete = true;
            setChangedData(prevState => {
              const updatedChangedData = { ...prevState };
              if (!updatedChangedData.hasOwnProperty('Family')) {
                  updatedChangedData.Family = [newData[index]];
              } else {
                  const i = updatedChangedData.Family.findIndex(rel => rel.RowKey === newData[index].RowKey);
                  if (i !== -1) {
                      updatedChangedData.Family[i].delete = true;
                  } else {
                      updatedChangedData.Family.push(newData[index]);
                  }
              }            
              return updatedChangedData;
            });
          }
          else {
            setChangedData(prevState => {
              const updatedChangedData = { ...prevState };
              const i = updatedChangedData.Family.findIndex(rel => rel.id === newData[index].id);
              if (i !== -1) {
                  updatedChangedData.Family.splice(i, 1);
              }                
              return updatedChangedData;
            });
            newData.splice(index, 1);
          }
          // updateChangedData('Family', newData);
          return newData;
      });
  };

  const isObjectEmpty = (data) => {
    for (const item of data) {
        for (const key in item) {
            if (typeof item[key] === 'object') {
                const subItem = item[key];
                for (const subKey in subItem) {
                    if (subItem[subKey] !== '') {
                        return false;
                    }
                }
            } else if (item[key] !== '') {
                return false;
            }
        }
    }
    return true;
  };

  return (
    <>
      <div className='profile-content'>      
        {allowedEdit && <button type='button' className='addButton' onClick={() => setShowRelativesModal(true)}><PlusOutlined /> Добавить родственника</button>}
        {!isObjectEmpty(relativesData) && relativesData.map((rel, index) => rel.delete !== true && (
          <div className={'itemCard'}>
            <h1>{rel.Name ? rel.Name : 'Не указано'}</h1>
            <p>{rel.RelationshipDegree.Name ? rel.RelationshipDegree.Name : 'Не указано'}</p>
            {allowedEdit && <div className={'actions'}>
              <button className="btn" onClick={() => {
                setNewRelativesData(rel);
                setEditRelatives(true);
                setEditRelativesIndex(index);
                setShowRelativesModal(true);
              }}><EditOutlined /></button>
              <button className="btn" onClick={() => handleRemoveRelativesRow(index)}><DeleteOutlined /></button>
            </div>}
          </div>
        ))}
        {showRelativesModal && (
          <>
              <div className="modal-bg" onClick={() => handleCloseRelativesModal()}></div>
              <div className="modal">
                  <h4 style={{ textAlign: "center", margin: "5px 0 15px" }}>Сведения о близком родственнике</h4>
                  <button type="button" className='btn' style={{ position: "absolute", top: "8px", right: "16px" }} onClick={() => handleCloseRelativesModal()} ><CloseOutlined /></button>
                  <table>
                    <tbody>
                      <tr>
                        <td width="40%"><p>Степень родства:</p></td>
                        <td width="60%">
                          <Select
                            size='small'
                            value={newRelativesData.RelationshipDegree.Name ? newRelativesData.RelationshipDegree.Name : undefined}
                            onChange={handleRelativesChange}
                            style={{ width: '100%' }}
                            placeholder="Выберите степень родства"
                            options={selectors.relationshipDegrees}
                            />
                        </td>
                      </tr>
                      <tr>
                        <td><p>Ф.И.О.:</p></td>
                        <td><input type="text" name="Name" value={newRelativesData.Name} onChange={handleRelativesChange} /></td>
                      </tr>
                      <tr>
                        <td><p>Дата рождения:</p></td>
                        <td><input type="date" name="BirthDate" value={newRelativesData.BirthDate ? newRelativesData.BirthDate.split('T')[0] : ''} onChange={handleRelativesChange} /></td>
                      </tr>
                      <tr>
                        <td><p>Страна рождения:</p></td>
                        <td>
                          {/* <Select
                            size='small'
                            value={newRelativesData.BirthPlace_Country.Name ? newRelativesData.BirthPlace_Country.Name : undefined}
                            onChange={handleRelativesChange}
                            showSearch
                            style={{ width: '100%' }}
                            optionFilterProp="children"
                            filterOption={(input, option) => option.label.toLowerCase().includes(input.toLowerCase())}
                            filterSort={(optionA, optionB) => optionA.label.toLowerCase().localeCompare(optionB.label.toLowerCase())}
                            placeholder="Выберите страну"
                            notFoundContent={<p style={{color: '#000'}}>Данный элемент отсутствует в базе данных! Оставьте заявку на добавление элемента в системе <a href="https://ithd.it/" target='_blank'>ServiceDesk</a></p>}
                            options={selectors.relBirthPlaceCountries}
                          /> */}
                          <AutoComplete
                            allowClear={true}
                            size='medium'
                            options={selectors.relBirthPlaceCountries}
                            style={{
                                width: '100%',
                            }}
                            value={newRelativesData.BirthPlace_Country.Name}
                            filterOption={(input, option) => option.label.toLowerCase().includes(input.toLowerCase())}
                            onSelect={(e, option) => handleRelativesChange(e, option)}
                            onChange={handleBirthPlaceCountryChange}
                            placeholder="Выберите страну"
                          />
                        </td>
                      </tr>
                      <tr>
                        <td><p>Должность:</p></td>
                        <td><input type="text" name="Position" value={newRelativesData.Position} onChange={handleRelativesChange} /></td>
                      </tr>
                      <tr>
                        <td><p>Место работы:</p></td>
                        <td><input type="text" name="WorkPlace" value={newRelativesData.WorkPlace} onChange={handleRelativesChange} /></td>
                      </tr>
                      <tr>
                        <td><p>Адрес:</p></td>
                        <td><input type="text" name="ResidencePlace" value={newRelativesData.ResidencePlace} onChange={handleRelativesChange} /></td>
                      </tr>
                    </tbody>
                  </table>
                  <div style={{ marginTop: "32px" }}></div>
                  <button className='btn' type='button' style={{ position: "absolute", bottom: "8px", right: "16px" }} onClick={handleAddRelativesRow}>ОК</button>
              </div>
          </>
        )}
      </div>


    
    
    </>
  );
};

export default RelativesInfo;
